import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../../src/assets/custom_styles.css";
import Getting_Started_img1 from "../assets/img/getting_started/Getting_Started_img1.png";
import Getting_Started_img2 from "../assets/img/getting_started/Getting_Started_img2.png";
import Getting_Started_img3 from "../assets/img/getting_started/Getting_Started_img3.png";
import signup_process_img1 from "../assets/img/signup_process/signup_process_img1.png";
import signup_process_img2 from "../assets/img/signup_process/signup_process_img2.png";
import signup_process_img3 from "../assets/img/signup_process/signup_process_img3.png";
import signup_process_img4 from "../assets/img/signup_process/signup_process_img4.png";
import signup_process_img5 from "../assets/img/signup_process/signup_process_img5.png";
import signup_process_img6 from "../assets/img/signup_process/signup_process_img6.png";
import login_process_img1 from "../assets/img/login_process/login_process_img1.png";
import login_process_img2 from "../assets/img/login_process/login_process_img2.png";
import login_process_img3 from "../assets/img/login_process/login_process_img3.png";
import change_password_img1 from "../assets/img/change_password_process/change_password_process_img1.png";
import change_password_img2 from "../assets/img/change_password_process/change_password_process_img2.png";
import change_password_img3 from "../assets/img/change_password_process/change_password_process_img3.png";
import forgot_password_img1 from "../assets/img/forgot_password_process/forgot_password_process_img1.png";
import forgot_password_img2 from "../assets/img/forgot_password_process/forgot_password_process_img2.png";
import forgot_password_img3 from "../assets/img/forgot_password_process/forgot_password_process_img3.png";
import forgot_password_img4 from "../assets/img/forgot_password_process/forgot_password_process_img4.png";
import forgot_password_img5 from "../assets/img/forgot_password_process/forgot_password_process_img5.png";
import profile_update_img1 from "../assets/img/profile_update_process/profile_update_process_img1.png";
import profile_update_img2 from "../assets/img/profile_update_process/profile_update_process_img2.png";
import profile_update_img3 from "../assets/img/profile_update_process/profile_update_process_img3.png";
import logout_img1 from "../assets/img/logout_process/logout_process_img1.png";
import logout_img2 from "../assets/img/logout_process/logout_process_img2.png";
import appendices_img from "../assets/img/appendices_img.png";
import Homepage_img1 from "../assets/img/Homepage_img/homepage_img1.png";
import Homepage_img2 from "../assets/img/Homepage_img/homepage_img2.png";
import Homepage_img3 from "../assets/img/Homepage_img/homepage_img3.png";
import Export_img1 from "../assets/img/Export_img/Export_img1.png";
import Export_img2 from "../assets/img/Export_img/Export_img2.png";
import factsheet_download_img1 from "../assets/img/Factsheets_download_img/Factsheet_img1.png";
import factsheet_download_img2 from "../assets/img/Factsheets_download_img/Factsheet_img2.png";
import factsheet_download_img3 from "../assets/img/Factsheets_download_img/Factsheet_img3.png";
import factsheet_download_img4 from "../assets/img/Factsheets_download_img/Factsheet_img4.png";
import Dataviz_img1 from "../assets/img/Dataviz_img/Dataviz_img1.png";
import Dataviz_img2 from "../assets/img/Dataviz_img/Dataviz_img2.png";
import Dataviz_img3 from "../assets/img/Dataviz_img/Dataviz_img3.png";
import Dataviz_img4 from "../assets/img/Dataviz_img/Dataviz_img4.png";
import Dataviz_img5 from "../assets/img/Dataviz_img/Dataviz_img5.png";
import Dataviz_img6 from "../assets/img/Dataviz_img/Dataviz_img6.png";
import Dataviz_img7 from "../assets/img/Dataviz_img/Dataviz_img7.png";
import Dataviz_img8 from "../assets/img/Dataviz_img/Dataviz_img8.png";
import Dataviz_img9 from "../assets/img/Dataviz_img/Dataviz_img9.png";
import Connect_withus_img1 from "../assets/img/Connect_withus_img/Connect_withus_img1.png";
const HelpSection = () => {
  const [activeTab, setActiveTab] = useState("a");
  const contentRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [activeTab, location.pathname]);

  const renderContent = () => {
    switch (activeTab) {
      case "a":
        return (
          <>
            <h5>Introduction and Overview</h5>
            <p>
              The TNCrest Visualization Portal is a web-based analytics platform
              designed to present structured cancer incidence and mortality
              statistics for Tamil Nadu. The portal converts registry data into
              interactive visualizations that support epidemiological analysis,
              district level monitoring, public health planning, and policy
              decision making.
            </p>
            <p>
              The data structure and statistical indicators align with the
              TNCrest 2020 analytical framework. The system supports data driven
              decision making and enables district level epidemiological
              assessment.
            </p>
            <br></br>
            {/* ---------------- */}
            <h5>Core Objectives of TNCrest</h5>

            <h6>Monitor Cancer Incidence</h6>
            <p>
              Track and analyze cancer occurrence patterns across different
              populations, geographic regions, and time periods to identify
              emerging trends.
            </p>
            <h6>Support Epidemiological Research</h6>
            <p>
              Provide researchers with comprehensive and structured datasets to
              investigate cancer causes, risk factors, and prevention
              strategies.
            </p>
            <h6>EnablePublic Health Planning</h6>
            <p>
              Inform policy decisions and resource allocation through
              evidence-based cancer statistics and projections for healthcare
              infrastructure.
            </p>
            <br></br>
            {/* ---------------- */}
            <h5>Purpose of the Visualization Portal</h5>
            <h6>Raw Data Conversion</h6>
            <p>
              Transform complex cancer registry data into intuitive visual
              analytics.
            </p>
            <h6>District Level Analysis</h6>
            <p>
              Enable detailed examination of regional cancer patterns across
              districts.
            </p>
            <h6>Trend Monitoring</h6>
            <p>Track temporal changes in cancer incidence and outcomes.</p>
            <h6>Policy Support</h6>
            <p>
              Provide evidence to support healthcare planning and policy
              decisions.
            </p>
          </>
        );
      case "b":
        return (
          <>
            <h5>System Requirements</h5>
            <p>
              To ensure optimal performance and compatibility, please ensure
              that your system meets the following recommendations.
            </p>
            <br></br>
            <h6>Web Browser</h6>
            <p>
              Latest versions of Google Chrome, Microsoft Edge, or Mozilla
              Firefox are recommended for optimal performance and compatibility
            </p>
            <h6>Memory (RAM)</h6>
            <p>
              Minimum 8 GB RAM recommended to support large datasets and
              interactive visualizations smoothly.
            </p>
            <h6>Screen Resolution</h6>
            <p>
              Minimum resolution of 1366 × 768 for proper display of charts and
              data tables.
            </p>
            <h6>Internet Connection</h6>
            <p>
              A stable broadband internet connection is required for data
              loading and real time analytics.
            </p>
          </>
        );
      case "c":
        return (
          <>
            <h5>User Access Levels</h5>
            <p>
              The portal operates with two primary access tiers based on user
              verification
            </p>
            <h6>Public Users</h6>
            <p>
              Guest access allows viewing of Fact Sheets, Methods, and Recent
              Cancer Statistics. Fact sheets are available for download. Data
              visualization features are limited to viewing only.
            </p>
            <h6>Authenticated Users</h6>
            <p>
              Users with verified credentials are granted full analytical
              capabilities, including advanced filtering, interactive data
              exploration, and comprehensive data export options.
            </p>
          </>
        );
      case "d":
        return (
          <>
            <h5>Getting Started</h5>
            <p>
              This section provides guidance on accessing the TNCrest
              Visualization Portal and understanding the main sections available
              on the landing page
            </p>
            <h6>Accessing the Portal</h6>
            <strong>Step1:</strong>
            <p>
              Open a web browser such as Google Chrome, Microsoft Edge, or
              Mozilla Firefox on your computer or mobile device
            </p>
            <img src={Getting_Started_img1} alt="Getting_Started_img1" />
            <br></br>
            <strong>Step2:</strong>
            <p>
              Type the TNCrest Visualization Portal address into the browser
              address bar:{" "}
              <a
                href="https://tn-crest.cancerinstitutewia.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://tn-crest.cancerinstitutewia.in/
              </a>
            </p>
            <img src={Getting_Started_img2} alt="Getting_Started_img2" />
            <br></br>
            <strong>Step3:</strong>
            <p>
              Once the portal loads, you may proceed in one of the following
              ways: Public Access to view limited information and downloadable
              fact sheets. User Login to access full analytical features and
              advanced data visualization tools.
            </p>
            <img src={Getting_Started_img3} alt="Getting_Started_img3" />
            <br></br>
            <h5>Landing Page Accessibility</h5>
            <p>
              The landing page of the portal provides access to several key
              sections through the main navigation menu.
            </p>
            <strong>Home</strong>
            <p>
              This is the default landing page of the TNCrest Visualization
              Portal. It provides an overview of the platform and quick access
              to important sections.
            </p>
            <strong>FactSheet</strong>
            <p>
              This section provides downloadable fact sheets containing
              summarized cancer statistics and related information.
            </p>
            <strong>Data Visualisation</strong>
            <p>
              This section contains interactive analytical dashboards,
              including:
            </p>
            <ul class="circle-list">
              <li>Recent Cancer Statistics</li>
              <li>Trend of Cancer Incidence</li>
              <li>Cancer Projection</li>
            </ul>
            <strong>Initiative</strong>
            <p>
              This section provides information about the initiative behind the
              portal, including details about the Cancer Institute (WIA).
            </p>
            <strong>Methods</strong>
            <p>
              This page contains information about the statistical methods,
              formulas, and calculation approaches used in the analysis.
            </p>
            <strong>Help</strong>
            <p>
              This section provides contact information and access to the User
              Manual for assistance in using the portal.
            </p>
            <strong>Log In</strong>
            <p>
              This option allows registered users to log in to their accounts.
              Account management features and the logout option are also
              available in this menu.
            </p>
          </>
        );
      case "e":
        return (
          <>
            <h5>Account Management</h5>
            <p>
              This section explains how users can create an account and access
              the TNCrest Visualization Portal.
            </p>
            <h6>Sign-Up Process</h6>

            <strong>Step 1:</strong>
            <p>
              Open the TNCrest Visualization Portal and click the Login button
              on the homepage.
            </p>
            <img src={signup_process_img1} alt="Sign_Up_img" />
            <br></br>
            <strong>Step 2:</strong>
            <p>You will be redirected to the Login Page.</p>
            <br></br>
            <strong>Step 3:</strong>
            <p>
              On the login page, click the Sign Up button to create a new
              account.
            </p>
            <img src={signup_process_img2} alt="Sign_Up_img" />
            <br></br>
            <strong>Step 4:</strong>
            <p>
              Enter the required registration details and click the Sign-Up
              button to submit your request.
            </p>
            <img src={signup_process_img3} alt="Sign_Up_img" />
            <br></br>
            <strong>Step 5:</strong>
            <p>
              After successful registration, you will be redirected back to the
              Login Page.
            </p>
            <img src={signup_process_img4} alt="Sign_Up_img" />
            <br></br>
            <strong>Step 6:</strong>
            <p>
              If you choose not to continue the process, click the Cancel
              button. This will stop the current process and return you to the
              previous screen without saving any changes.
            </p>
            <img src={signup_process_img5} alt="Sign_Up_img" />
            <br></br>
            <p>
              You will be redirected to the login page when after selecting the
              “Cancel” button
            </p>
            <img src={signup_process_img6} alt="Sign_Up_img" />
            {/* ---------------- */}
            <h6>Login Process</h6>
            <p>
              Follow the steps below to log in to the TNCrest Visualization
              Portal.
            </p>
            <strong>Step 1:</strong>
            <p>
              After completing the sign-up process, check your registered email
              address to receive your login password.
            </p>
            <img src={login_process_img1} alt="login_process_img" />
            <br></br>
            <strong>Step 2:</strong>
            <p>
              Open the Login Page of the TNCrest Visualization Portal and enter
              the following details:
            </p>
            <ul class="circle-list">
              <li>Registered Email ID.</li>
              <li>Password received via email</li>
            </ul>
            <br></br>
            <strong>Step 3:</strong>
            <p>Click the Submit button to proceed.</p>
            <img src={login_process_img2} alt="login_process_img" />
            <br></br>
            <strong>Step 4:</strong>
            <p>
              After successful authentication, you will be redirected to the
              Data Visualization Dashboard, where you can access analytical
              features and explore cancer data visualizations.
            </p>
            <img src={login_process_img3} alt="login_process_img" />
            <br></br>
            {/* ----------- */}
            <h5>Password Management</h5>
            <p>
              This section explains how users can manage their account
              passwords, including changing the existing password and resetting
              a forgotten password.
            </p>
            <h6>Change Password</h6>
            <p>Follow the steps below to change your account password.</p>
            <strong>Step 1:</strong>
            <p>
              Click the Profile icon located at the top corner of the portal
              interface.
            </p>
            <strong>Step 2:</strong>
            <p>From the dropdown menu, select Change Password.</p>
            <img src={change_password_img1} alt="change_password_img" />
            <br></br>
            <strong>Step 3:</strong>
            <p>You will be redirected to the Change Password Page</p>
            <strong>Step 4:</strong>
            <p>Enter the following details in the respective fields:</p>
            <ul class="circle-list">
              <li>Old Password</li>
              <li>New Password</li>
              <li>Confirm Password</li>
            </ul>
            <img src={change_password_img2} alt="change_password_img" />
            <br></br>
            <strong>Step 5:</strong>
            <p>
              After updating the password, a confirmation notification will
              appear indicating that the password has been changed successfully.
            </p>
            <img src={change_password_img3} alt="change_password_img" />
            <br></br>
            <h6>Forgot Password</h6>
            <p>
              If you forget your password, follow the steps below to reset it.
            </p>
            <strong>Step 1:</strong>
            <p>
              On the Login Page, click the Forgot Password option located on the
              right side of the login form.
            </p>
            <img src={forgot_password_img1} alt="forgot_password_img" />
            <br></br>
            <strong>Step 2:</strong>
            <p>
              Enter your registered Email ID and click the Send Password button.
            </p>
            <img src={forgot_password_img2} alt="forgot_password_img" />
            <br></br>
            <strong>Step 3:</strong>
            <p>
              Open the email sent to your registered email address and click the
              Reset Password button.
            </p>
            <img src={forgot_password_img3} alt="forgot_password_img" />
            <br></br>
            <strong>Step 4:</strong>
            <p>
              Enter a new password and confirm it to complete the password reset
              process.
            </p>
            <img src={forgot_password_img4} alt="forgot_password_img" />
            <br></br>
            <strong>Step 5:</strong>
            <p>
              After successfully resetting the password, you will be redirected
              to the Login Page.
            </p>
            <img src={forgot_password_img5} alt="forgot_password_img" />
            <br></br>
            <h6>Update or Edit Profile</h6>
            <p>
              This section explains how users can view and update their profile
              information in the TNCrest Visualization Portal.
            </p>
            <strong>Step 1:</strong>
            <p>
              Click the Profile icon located at the top corner of the portal
              interface.
            </p>
            <strong>Step 2:</strong>
            <p>From the dropdown menu, select Profile.</p>
            <img src={profile_update_img1} alt="profile_img" />
            <strong>Step 3:</strong>
            <p>
              You will be redirected to the Profile Page, where your account
              details are displayed.
            </p>
            <strong>Step 4:</strong>
            <p>
              Update the required information and click the Update Profile
              button to save the changes.
            </p>
            <img src={profile_update_img2} alt="profile_img" />
            <br></br>
            <strong>Step 5:</strong>
            <p>
              s After successful submission, a confirmation notification will
              appear stating “Profile Updated Successfully.”
            </p>
            <img src={profile_update_img3} alt="profile_img" />
            <br></br>
            {/* ----------------- */}
            <h6>Logout</h6>
            <p>
              This section explains how users can securely log out from the
              TNCrest Visualization Portal.
            </p>
            <strong>Step 1:</strong>
            <p>
              Click the Profile icon located at the top corner of the portal
              interface
            </p>
            <strong>Step 2:</strong>
            <p>From the dropdown menu, select the Logout option</p>
            <img src={logout_img1} alt="logout_img" />
            <br></br>
            <strong>Step 3:</strong>
            <p>
              You will be logged out of the portal and redirected to the Login
              Page.
            </p>
            <img src={logout_img2} alt="logout_img" />
          </>
        );
      case "f":
        return (
          <>
            <h5>Portal:Step-by-Step Guide</h5>

            <p>
              Understanding the user interface (UI) flow is essential for
              efficiently navigating and analyzing the data available in the
              portal. Follow the steps below to utilize the portal's core
              features.
            </p>
            <h6>Home Page Dashboard</h6>
            <p>
              After a successful login, you will be directed to the Home Page
              Dashboard. This dashboard serves as the main entry point for
              accessing the portal’s analytical features.
            </p>
            <p>
              The center of the dashboard provides three primary sections that
              allow users to begin exploring cancer data.
            </p>
            <h6>Recent Cancer Statistics</h6>
            <p>
              This section provides access to the most recent cancer statistics
              available in the portal. Users can explore summarized data and
              visual representations of current cancer incidence and related
              indicators.
            </p>
            <img src={Homepage_img1} alt="Homepage_img" />
            <br></br>
            <h6>Trend of Cancer Incidence</h6>
            <p>
              This section allows users to analyze historical trends in cancer
              incidence across different time periods and geographic regions.
            </p>
            <img src={Homepage_img2} alt="Homepage_img" />
            <br></br>
            <h6>Cancer Projection</h6>
            <p>
              This section provides projections of future cancer incidence based
              on statistical models and historical data patterns. These
              projections support planning and policy level decision making.
            </p>
            <img src={Homepage_img3} alt="Homepage_img" />
            <br></br>
            <h5>Downloading Fact Sheets</h5>
            <p>
              The Fact Sheets section allows users to download summarized cancer
              statistics based on selected filters such as population, district,
              or cancer type.
            </p>
            <p>Follow the steps below to download a fact sheet:</p>
            <strong>Step 1:</strong>
            <p>
              Navigate to the Fact Sheets section from the navigation bar
              located at the top of the Home Page.
            </p>
            <img src={factsheet_download_img1} alt="Factsheet_img" />
            <br></br>
            <strong>Step 2:</strong>
            <p>
              Use the Display dropdown menu to select how you want to filter the
              fact sheet. Available options may include:
            </p>
            <ul class="circle-list">
              <li>Population</li>
              <li>District</li>
              <li>Cancer</li>
            </ul>
            <img src={factsheet_download_img2} alt="Factsheet_img" />
            <br></br>
            <strong>Step 3:</strong>
            <p>
              Based on your selected display option, choose the required filter
              value such as:
            </p>
            <ul class="circle-list">
              <li>
                District Name (for example: All Districts, Ariyalur, Chennai)
              </li>
              <li>
                Cancer Type (for example: All Cancers, C31 Accessory Sinuses),
              </li>
            </ul>
            <img src={factsheet_download_img3} alt="Factsheet_img" />
            <br></br>
            <strong>Step 4:</strong>
            <p>
              Click the Download Factsheet button to generate and download the
              document.
            </p>
            <img src={factsheet_download_img4} alt="Factsheet_img" />
            <br></br>
            <h5>Utilizing Data Visualizations</h5>
            <p>
              The Data Visualization section allows users to explore cancer
              statistics through interactive charts, tables, and graphical
              representations. Users can apply filters to customize the dataset
              and view the results in different visual formats.
            </p>
            <p>
              Follow the steps below to use the Data Visualization features.
            </p>
            <strong>Step 1:</strong>
            <p>
              Navigate to the Data Visualization tab located in the navigation
              bar next to the Fact Sheets section.
            </p>
            <img src={Dataviz_img1} alt="Data_Visualization_img" />
            <br></br>
            <strong>Step 2:</strong>
            <p>
              Click the Data Visualization tab. You will be redirected to the
              Data Visualization Page, where interactive dashboards and
              filtering tools are available.
            </p>
            <img src={Dataviz_img2} alt="Data_Visualization_img" />
            <br></br>
            <strong>Step 3:</strong>
            <p>
              On the left side of the screen, use the Available Filtering
              Methods dropdown menus to refine and customize the dataset.
            </p>
            <p>The available filtering options include:</p>
            <strong>Select Category</strong>
            <p>
              Choose the category of analysis such as By Place, By Cancer, or
              ASPR.
            </p>
            <strong>Site of Cancer</strong>
            <p>
              Select All Cancers Together or choose a specific cancer site such
              as C67 Bladder.
            </p>
            <strong>Gender</strong>
            <p>Filter the data by Both, Male, or Female.</p>
            <strong>Residence District</strong>
            <p>
              Analyze data for All Districts Together or select a specific
              district.
            </p>
            <strong>Age at Diagnosis</strong>
            <p>
              Specify the age group range for analysis, for example from 0 to 75
              plus.
            </p>
            <strong>Year of Diagnosis or Projection Year</strong>
            <p>Select the required year or range of years for the analysis.</p>
            <strong>Rates</strong>
            <p>Choose the type of statistical rate to display:</p>
            <ul class="circle-list">
              <li>Number of Cases</li>
              <li>Crude Incidence Rate (CIR)</li>
              <li>Age Standardized Rate(ASR)</li>
            </ul>
            <img src={Dataviz_img3} alt="Data_Visualization_img" />
            <br></br>
            <strong>Step 4:</strong>
            <p>
              At the top of the main data panel, use the Data Visualization
              Format icons to switch between different visual representations of
              the dataset.
            </p>

            <p>The available visualization formats include:</p>
            <strong>a. Statistical Data Table</strong>
            <p>Displays the dataset in a structured tabular format.</p>
            <img src={Dataviz_img4} alt="Data_Visualization_img" />
            <br></br>
            <strong>b. Multi colour Pie Chart</strong>
            <p>
              Displays the proportional distribution of data across selected
              categories.
            </p>
            <img src={Dataviz_img5} alt="Data_Visualization_img" />
            <br></br>
            <strong>c. Interactive Treemap</strong>
            <p>
              Displays proportional data distribution using nested rectangles
              based on volume.
            </p>
            <img src={Dataviz_img6} alt="Data_Visualization_img" />
            <br></br>
            <strong>d. Horizontal Bar Chart</strong>
            <p>
              Displays comparative values across categories using horizontal
              bars.
            </p>
            <img src={Dataviz_img7} alt="Data_Visualization_img" />
            <br></br>
            <strong>e. Trend Line Graph</strong>
            <p>Displays trends and patterns in the data over time.</p>
            <img src={Dataviz_img8} alt="Data_Visualization_img" />
            <br></br>
            <strong>Step 5:</strong>
            <br></br>
            <strong>Switching Modules Using Footer Navigation </strong>
            <br></br>
            <p>
              While on the Data Visualization Page, users can switch between the
              three main analytical modules by using the navigation options
              located at the bottom of the page.
            </p>
            <p>These modules include:</p>
            <strong>Recent Cancer Statistics </strong>
            <p>
              Displays historical cancer incidence records and summarized
              statistical data.
            </p>
            <strong> Trend of Cancer Incidence</strong>
            <p>
              Allows users to track temporal changes and analyze statistical
              rates across a timeline.
            </p>
            <strong>Cancer Projection </strong>
            <p>
              Provides projected cancer incidence estimates based on statistical
              models and historical data.
            </p>
            <img src={Dataviz_img9} alt="Data_Visualization_img" />
            <br></br>
            <h5>Exporting and Reporting Data </h5>
            <p>
              The TNCrest Visualization Portal empowers authenticated users to
              seamlessly export diverse content formats, tailored to specific
              analytical and reporting requirements.
            </p>
            <h5>Exporting Data Tables</h5>
            <p>
              Users can export structured datasets for further analysis or
              reporting. Data tables can be downloaded in CSV, PDF, or Excel
              formats.
            </p>
            <p>Follow the steps below to export a data table.</p>
            <strong>Step 1:</strong>
            <p>
              Navigate to the required data table within the Data Visualization
              section.
            </p>
            <strong>Step 2:</strong>
            <p>Locate the download icons positioned above the data table.</p>
            <strong>Step 3:</strong>
            <p>
              Click the appropriate icon to download the file in your preferred
              format:
            </p>
            <ul class="circle-list">
              <li>CSV</li>
              <li>PDF</li>
              <li>Excel</li>
            </ul>
            <p>The file will be generated and downloaded to your device.</p>
            <img src={Export_img1} alt="Export_img" />
            <br></br>
            <h5>Exporting Graphical Visualizations</h5>
            <p>
              All graphical visualizations such as charts and treemaps can be
              exported for use in reports, presentations, or further analysis.
              These visualizations can be downloaded in formats such as SVG,
              PNG, or CSV.
            </p>
            <p>Follow the steps below to export a graphical visualization.</p>
            <strong>Step 1:</strong>
            <p>
              Navigate to the required chart or visualization on the Data
              Visualization page.
            </p>
            <strong>Step 2:</strong>
            <p>
              Click the menu icon represented by three horizontal lines located
              at the top right corner of the chart.
            </p>
            <strong>Step 3:</strong>
            <p>A list of download options will appear.</p>
            <strong>Step 4:</strong>
            <p>Select the required format such as:</p>
            <ul class="circle-list">
              <li>SVG</li>
              <li>PNG</li>
              <li>CSV</li>
            </ul>
            <strong>Step 5:</strong>
            <p>
              The selected chart will be downloaded to your device in the chosen
              format.
            </p>
            <img src={Export_img2} alt="Export_img" />
            <br></br>
            <h5>Global Navigation, Footer and Privacy Policy</h5>
            <p>
              At the bottom of the portal pages, along with the module switching
              options, you will find the global footer section. This section
              provides quick access to important information, institutional
              policies, and support resources.
            </p>
            <p>The footer includes the following components.</p>
            <h6>Privacy and Institutional Policy</h6>
            <p>
              The portal maintains strict confidentiality and data governance
              standards. Unauthorized distribution, disclosure, or misuse of
              proprietary information is strictly prohibited.
            </p>
            <p>
              Users must adhere to all institutional policies, which include:
            </p>
            <ul class="circle-list">
              <li>
                Avoiding the redistribution of raw data obtained from the portal
              </li>
              <li>
                Using statistical projections and analytical outputs responsibly
              </li>
              <li>
                Ensuring that data is used only for authorized research or
                analytical purposes
              </li>
            </ul>
            <h6>About TN CReSt</h6>
            <p>
              This section provides background information about the Tamil Nadu
              Cancer Registry Project (TN CReSt), including its objectives,
              scope, and contribution to cancer surveillance and public health
              planning in Tamil Nadu.
            </p>
            <br></br>
            <h6>Connect With Us</h6>
            <p>
              This section provides contact and support information for users
              who require assistance with the portal. It may include contact
              details for technical support, institutional communication
              channels, or other relevant help resources.
            </p>
            <img src={Connect_withus_img1} alt="Connect_img" />
          </>
        );
      case "g":
        return (
          <>
            <h5>Data Coverage and Definitions</h5>
            <p>
              This section outlines the scope of the data available in the
              TNCrest Visualization Portal, including the time periods covered
              and key definitions used in the analysis of cancer statistics.
            </p>
            <br></br>
            <h5>Coverage Timeframes</h5>
            <p>
              The portal contains both historical cancer data and projected
              estimates to support epidemiological analysis and future planning.
            </p>
            <h6>Historical Data (Years Covered: 2012 to 2023)</h6>
            <p>
              This dataset includes actual recorded cancer cases obtained from
              registry records. The data contains verified incidence records
              along with demographic classifications such as age group, gender,
              and district of residence.
            </p>
            <h6>Projection Data (Years Covered: 2024 to 2030)</h6>
            <p>
              These datasets represent statistical projections generated using
              historical trends and analytical models to estimate future cancer
              incidence patterns.
            </p>
            <h6>Additional Classifications</h6>
            <p>
              All datasets include the following classifications to support
              detailed analysis:
            </p>
            <ul class="circle-list">
              <li>District wise coverage</li>
              <li>Gender distribution</li>
              <li>Age group categorization</li>
            </ul>
            <p>
              These classifications enable comprehensive epidemiological
              analysis across different population segments.
            </p>
            <h6>Definitions</h6>
            <p>
              The following definitions are used throughout the portal and
              related analytical outputs.
            </p>
            <strong>Cancer Case Definition</strong>
            <br></br>
            <p>
              A confirmed diagnosis of cancer based on medical records and
              pathological reports.All neoplasms with behavior code “3”
              according to the International Classification of Diseases for
              Oncology (ICD O Third Edition) are considered reportable and are
              included in the cancer registry.
            </p>
            <br></br>
            <strong>Age Group Classification</strong>
            <p>
              Age groups follow the World Health Organization standard five year
              intervals, such as:
            </p>
            <p>
              0 to 4, 5 to 9, 10 to 14, continuing up to 75 years and above.
            </p>
            <p>
              Childhood cancer cases are defined as individuals aged 0 to 19
              years.
            </p>
            <br></br>
            <strong>Incidence Definition</strong>
            <p>
              Cancer incidence refers to the number of new cancer cases
              diagnosed within a defined population during a specific time
              period and geographic area.
            </p>
            <p>
              All cancer incidence rates in the portal are expressed per 100,000
              population, following international epidemiological standards.
            </p>
          </>
        );
      case "h":
        return (
          <>
            <h5>Troubleshooting</h5>
            <p>
              While using the TNCrest Visualization Portal, users may
              occasionally encounter minor technical issues related to data
              display, loading speed, or filter selections. The following
              troubleshooting steps can help resolve the most common problems
              before contacting technical support.
            </p>

            <h6>Charts Not Loading Properly</h6>

            <strong>Issue</strong>
            <p>
              Charts or visualizations fail to load or appear blank on the
              screen.
            </p>

            <strong>Solution</strong>
            <p>
              Clear your browser cache and refresh the page. Using the latest
              version of a supported browser such as Google Chrome, Microsoft
              Edge, or Mozilla Firefox can also help resolve most display
              related issues.
            </p>
            <br></br>
            <h6>Data Not Refreshing</h6>
            <strong>Issue</strong>
            <p>
              Updated results do not appear after applying new filters or
              changing selections.
            </p>
            <strong>Solution</strong>
            <p>
              Reset all filters to their default settings and then reapply the
              required filters. Ensure that all filter fields have valid
              selections before generating the visualization.
            </p>
            <br></br>
            <h6>Incorrect Numbers Displayed</h6>
            <strong>Issue</strong>
            <p>
              The displayed statistics appear inconsistent with the expected
              results.
            </p>
            <strong>Solution</strong>
            <p>
              Verify that the correct category, indicator, time period, and
              geographic selection have been applied in the filtering options.
            </p>
            <br></br>
            <h6>Slow Loading Times</h6>
            <strong>Issue</strong>
            <p>
              The portal takes longer than expected to load charts, tables, or
              visualizations.
            </p>
            <strong>Solution</strong>
            <p>
              Ensure that your internet connection is stable. Close unnecessary
              browser tabs or background applications to improve system
              performance. A system with sufficient memory and a supported
              browser will ensure smoother operation.
            </p>
          </>
        );
      case "i":
        return (
          <>
            <h5>Data Governance</h5>
            <p>Users must adhere to the following guidelines:</p>
            <ol class="numbered-list">
              <li>
                Cite TNCReSt appropriately when using data, visualizations, or
                analytical outputs derived from the portal.
              </li>
              <li>
                Avoid redistribution of raw data obtained from the portal
                without proper authorization.
              </li>
              <li>
                Use statistical projections responsibly, ensuring they are
                interpreted within the appropriate analytical context.
              </li>
              <li>
                Follow all institutional policies and applicable data governance
                standards.
              </li>
            </ol>
          </>
        );
      case "j":
        return (
          <>
            <h5>Conclusion</h5>
            <p>
              The TNCReSt Visualization Portal provides an interactive and
              structured platform for analyzing cancer incidence statistics
              across Tamil Nadu. The portal enables users to explore
              epidemiological data through visualizations, statistical tables,
              and analytical tools designed to support research and public
              health monitoring.
            </p>
            <p>
              The system supports data driven decision making and facilitates
              district level epidemiological assessment, helping policymakers,
              researchers, and healthcare institutions better understand cancer
              trends and patterns.
            </p>
            <p>
              This user manual should be reviewed and updated periodically under
              the following circumstances:
            </p>
            <ul class="circle-list">
              <li>When new cancer registry data is published</li>
              <li>
                When projection models or analytical methodologies are revised
              </li>
              <li>
                When new features or enhancements are introduced to the portal
              </li>
            </ul>
            <p>
              Regular updates to this manual will ensure that users continue to
              have accurate guidance for effectively using the TNCrest
              Visualization Portal.
            </p>
          </>
        );
      case "k":
        return (
          <>
            <h5>Appendices</h5>
            <h6>Appendix A: Abbreviations and Acronyms</h6>
            <p>
              This section lists commonly used abbreviations and acronyms used
              in the TNCrest Visualization Portal.
            </p>
            <img src={appendices_img} alt="Appendices" />
            <br></br>
            <h6>Appendix B: Document Control</h6>
            <p>
              The following information provides version control and document
              management details for this user manual.
            </p>
            <strong>Current Version</strong>
            <p>V3.0 (Updated document)</p>
            <strong>Previous Versions </strong>
            <ul class="circle-list">
              <li>V1.0 (23 February 2026)</li>
              <li>V2.0 (26 February 2026)</li>
            </ul>
            <strong>Confidentiality Notice</strong>
            <p>
              This document contains confidential and proprietary information
              intended solely for the designated recipient. Unauthorized
              distribution, disclosure, or use of this document is strictly
              prohibited.
            </p>
            <strong>Copyright</strong>
            <p>© 2026 All rights reserved by Evolve Bizcon Pvt Ltd.</p>
            <br></br>
            <strong>Note</strong>
            <p>This manual should be updated whenever:</p>
            <ul class="circle-list">
              <li>new registry data is published</li>
              <li>projection models are revised</li>
              <li>portal features are enhanced</li>
            </ul>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container my-4 ">
      <h5>Help</h5>
      <p>Navigate on below Topics:</p>

      <div className="row">
        {/* Left Side Tabs */}
        <div className="col-md-3">
          <div className="list-group p-1">
            <button
              className={`list-group-item list-group-item-action  ${
                activeTab === "a" ? "active" : ""
              }`}
              onClick={() => setActiveTab("a")}
            >
              Introduction and Overview
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "b" ? "active" : ""
              }`}
              onClick={() => setActiveTab("b")}
            >
              System Requirements
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "c" ? "active" : ""
              }`}
              onClick={() => setActiveTab("c")}
            >
              User Access Levels
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "d" ? "active" : ""
              }`}
              onClick={() => setActiveTab("d")}
            >
              Getting Started
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "e" ? "active" : ""
              }`}
              onClick={() => setActiveTab("e")}
            >
              Account Management
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "f" ? "active" : ""
              }`}
              onClick={() => setActiveTab("f")}
            >
              Portal Step-by-Step Guide
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "g" ? "active" : ""
              }`}
              onClick={() => setActiveTab("g")}
            >
              Data Coverage and Definitions
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "h" ? "active" : ""
              }`}
              onClick={() => setActiveTab("h")}
            >
              Troubleshooting
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "i" ? "active" : ""
              }`}
              onClick={() => setActiveTab("i")}
            >
              Data Governance
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "j" ? "active" : ""
              }`}
              onClick={() => setActiveTab("j")}
            >
              Conclusion
            </button>

            <button
              className={`list-group-item list-group-item-action ${
                activeTab === "k" ? "active" : ""
              }`}
              onClick={() => setActiveTab("k")}
            >
              Appendices
            </button>
          </div>
        </div>

        {/* Right Side Content */}
        <div
          ref={contentRef}
          className="col-md-9 border pt-1 p-3 tab-content-area"
          style={{ maxHeight: "60vh", overflowY: "auto" }}
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default HelpSection;
